import { Link } from "react-router-dom";
import { CloudRain, Sun, Wind } from "lucide-react";
import { Panel, itDate, useList } from "@/components/kit";

const TONE = { alto: "border-[#FCA5A5] bg-[#FEF2F2]", medio: "border-[#FCD34D] bg-[#FFFBEB]", basso: "border-[#BBF7D0] bg-[#F0FDF4]" };

export function WeatherPanel() {
  const [rows] = useList("/weather/events");
  if (!rows?.length) return null;
  return (
    <Panel title="Meteo dei prossimi eventi" testId="weather-panel" right={<span className="text-xs text-[#7B929C]">Bovalino • Open-Meteo</span>}>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {rows.map((w) => (
          <Link key={w.id} to={`/contratti/${w.id}`} className={`rounded-xl border p-4 space-y-1 transition-transform hover:-translate-y-0.5 ${TONE[w.rischio]}`} data-testid={`weather-${w.number}`}>
            <div className="flex justify-between text-sm"><b>{itDate(w.data)}{w.ora && ` • ${w.ora}`}</b><span className="text-xs uppercase">{w.rischio === "basso" ? "ok" : `rischio ${w.rischio}`}</span></div>
            <div className="text-sm">{w.evento_tipo} • {w.cliente}</div>
            <div className="text-xs text-[#47606B]">{w.sede}</div>
            <div className="flex gap-3 text-sm pt-1"><span><CloudRain size={14} className="inline mr-0.5" />{w.pioggia_prob}%{w.pioggia_mm ? ` • ${w.pioggia_mm}mm` : ""}</span><span><Wind size={14} className="inline mr-0.5" />{w.raffiche} km/h</span><span><Sun size={14} className="inline mr-0.5" />{w.temp_min}–{w.temp_max}°</span></div>
            {w.rischio !== "basso" && <div className="text-xs font-semibold text-[#991B1B] pt-1">Prepara il piano B al coperto e avvisa cliente e allestitori</div>}
          </Link>
        ))}
      </div>
    </Panel>
  );
}
